import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import OnboardingProgressBar from "./OnboardingProgressBar";
import { ArrowPathIcon } from "@heroicons/react/24/solid";

const WizardStep = ({
  children,
  nextEnabled = true,
  handleNextClick,
  handleSkipStepClick,
  currentStep = 1,
  loading = false,
}) => {
  useEffect(() => {
    const originalBackgroundColor = document.body.style.backgroundColor;

    document.body.style.backgroundColor = "#F0F0EE";

    // Cleanup function to revert the background color when the component unmounts
    return () => {
      document.body.style.backgroundColor = originalBackgroundColor;
    };
  }, []);

  return (
    <form
      onSubmit={handleNextClick}
      className="flex flex-col bg-white min-h-screen gap-6 items-center"
    >
      <header className="border-b border-gray-300 p-4 w-full">
        <Link to="/onboarding">
          <img alt="SupportMagic" src="/logo.png" className="h-8" />
        </Link>
      </header>

      <main className="flex flex-col gap-6 flex-1">
        {children}

        {typeof handleNextClick === "function" && (
          <button
            type="submit"
            className={`flex justify-center rounded-md px-3 py-2 text-sm disabled:cursor-not-allowed
              ${
                nextEnabled
                  ? "bg-primary cursor-pointer hover:bg-primary focus:ring-2 focus:outline-none focus:ring-offset-2 focus:bg-primary disabled:bg-primary text-white"
                  : "bg-gray-100 cursor-not-allowed text-gray-400"
              }
              font-semibold leading-6 shadow-sm mb-2.5 w-full`}
            disabled={!nextEnabled || loading}
          >
            {loading ? (
              <ArrowPathIcon className="size-6 animate-spin" />
            ) : (
              <span>Continue</span>
            )}
          </button>
        )}

        {typeof handleSkipStepClick === "function" && (
          <button
            type="button"
            className="flex justify-center px-10 py-2 text-sm cursor-pointer border-none bg-none text-primary font-semibold"
            onClick={handleSkipStepClick}
          >
            Skip this step
          </button>
        )}
      </main>

      <footer className="flex justify-center pb-24">
        <OnboardingProgressBar currentStep={currentStep} />
      </footer>
    </form>
  );
};

export default WizardStep;
